module.exports = __webpack_public_path__ + "static/img/91BM-056-LuceZhang.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stars/91BM-056-LuceZhang.jpg
// module id = KXSJ
// module chunks = 0